export const React_Google_API_Key = "AIzaSyCdN5Odk_cCdN26T5jjqLxLIb_s7pB5O-4"; // CHANGE 12-Feb-24
